import { HostListener, Component, AfterContentChecked,  OnInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { NgbPaginationModule, NgbPaginationConfig } from '@ng-bootstrap/ng-bootstrap';
import { PictureBe } from '../../app/image-library/shared/image-model';
import { ErrorObject } from '../../app/errorhandler/gpiserror-object';
import { ErrorHandlerService } from '../../app/errorhandler/gpiserror-handler.service';
import { PackagingMaterialSearchService } from './packaging-material-search.service';
import { IReturnObject } from '../shared/return-object.model';
import { ErrorTypeEnum } from '../shared/enums.model';
import { UserHandling } from '../shared/user-handling';
import { AttributeListBE } from '../shared/attribute-list.model';
import { AppConfig } from '../config/app.config';
import { MaterialSearchList } from '../packaging-material/shared/packaging-material.model';
import { PackagingMaterialService } from '../../app/packaging-material/packaging-material.service';
import { ComponentCanDeactivate } from '../../app/shared/page.pendingchangesguard';
import { SetFocus } from '../../app/shared/setFocus';

@Component({
    moduleId: module.id,
    selector: 'packaging-material-search',
    templateUrl: 'packaging-material-search.html',
    providers: [PackagingMaterialSearchService, PackagingMaterialService, NgbPaginationConfig, NgbPaginationModule]
})
export class PackagingMaterialSearchComponent implements OnInit, AfterContentChecked, ComponentCanDeactivate {
    listOfMh: Array<MaterialSearchList>= null;
    listOfMhTemp: Array<MaterialSearchList> = null;
    pageMhData: Array<MaterialSearchList> = [];
    user: UserHandling = new UserHandling();
    packagingOwnersList: AttributeListBE[] = [];
    statutesList: AttributeListBE[] = [];

    // paging
    pagerPage = 1;
    numPages = 1;
    collectionSize = 0;

    // search
    searchMHNo = '';
    searchDescription = '';
    searchStatusIds: number[] = [];
    searchOwnerId = 1;
    searchLengthFrom?: number = null;
    searchLengthTo?: number = null ;
    searchWidthFrom?: number = null ;
    searchWidthTo?: number = null ;
    searchHeightFrom?: number = null ;
    searchHeightTo?: number = null ;

    // sort and filter
    filterField = '';
    filterText = '';
    sortField = 'MHNo';
    sortOrder = 'desc';

    // misc
    setFocus: SetFocus = new SetFocus();
    selectedPmId: number;
    pmName = '';
    isFocusSet = false;
    showSpinner = false;

    public static SetBase64Imageforpreview(pic: PictureBe) {
        const img: any = 'data:image/png;base64,' + pic.PictureImage;
        pic.PictureImage = img;
    }

    constructor(private config: AppConfig,
        private pkgSearchService: PackagingMaterialSearchService,
        private paginationConfig: NgbPaginationConfig,
        private packagingMaterialService: PackagingMaterialService,
        private errHandler: ErrorHandlerService
    ) {
        paginationConfig.pageSize = 30;
        paginationConfig.ellipses = true;
        paginationConfig.directionLinks = true;
        paginationConfig.boundaryLinks = true;
        paginationConfig.maxSize = 30;
        this.collectionSize = 0;
    }

    @HostListener('window:beforeunload')
    canDeactivate(): Observable<boolean> | boolean {
        return true;
    }


    // ----------------------------------------------------------
    // Life cycle hooks
    // ----------------------------------------------------------
    ngOnInit(): void {
        this.showSpinner = false;
        this.getStatuses();
        this.setDefaultStatusSelection();
        this.getPackagingOwners();
    }

    ngAfterContentChecked() {
        this.isFocusSet = this.setFocus.to('mhno', this.isFocusSet);
    }


    // ----------------------------------------------------------
    // Get data
    // ----------------------------------------------------------
    getPackagingOwners() {
        this.errHandler.emitErrorObject(null);
        this.packagingMaterialService.getPackagingOwners()
            .subscribe(returnObject => this.getPackagingOwnersResponse(returnObject));
    }

    getPackagingOwnersResponse(returnObject: IReturnObject) {
        if (returnObject.ErrorType !== ErrorTypeEnum.NoError) {
            this.errHandler.emitError(returnObject.ErrorMsg, 'PackagingMaterialComponent.getPackagingOwnersResponse', returnObject.ErrorType);
        } else {
            this.packagingOwnersList = returnObject.DataList;
            this.searchOwnerId = -1;
        }
    }

    getStatuses() {
        let item = new AttributeListBE(1, 'Preliminary');
        this.statutesList.push(item);
        item = new AttributeListBE(5, 'Active');
        this.statutesList.push(item);
        item = new AttributeListBE(8, 'Phasing Out');
        this.statutesList.push(item);
        item = new AttributeListBE(6, 'Scrapped');
        this.statutesList.push(item);
    }


    // ----------------------------------------------------------
    // Search
    // ----------------------------------------------------------
    searchResult(returnObject: IReturnObject) {
        this.listOfMh = null;
        if ( returnObject.ErrorType !== ErrorTypeEnum.NoError ) {
            this.error(returnObject.ErrorMsg, 'PackagingSearchComponent.searchResult', returnObject.ErrorType );
        } else {

            this.listOfMh = returnObject.DataList;
            this.sort();
            this.collectionSize = this.listOfMh.length;
            if ( this.collectionSize > 0) {
                this.pageChanger();
            }
        }
        this.showSpinner = false;
    }

    search() {
        this.errHandler.emitErrorObject(null);
        this.showSpinner = true;
        this.pagerPage = 1;
        this.collectionSize = 0;
        this.filterText = '';
        this.listOfMh = null;
        this.pageMhData = [];
        this.listOfMhTemp = null;
        this.filterField = '';

        this.pkgSearchService.listOfMaterialSearch(this.searchMHNo,
            this.searchDescription,
            this.searchStatusIds.join(','),
            this.searchOwnerId,
            this.searchLengthFrom,
            this.searchLengthTo,
            this.searchWidthFrom,
            this.searchWidthTo,
            this.searchHeightFrom,
            this.searchHeightTo)
            .subscribe(returnObject => this.searchResult(returnObject));
    }


    // ----------------------------------------------------------
    // Pagination methods
    // ----------------------------------------------------------
    pageChanger() {
        this.showSpinner = true;
        const numToSkip = ( this.pagerPage - 1 ) * this.paginationConfig.pageSize;
        const lastPageCount = this.collectionSize % 30;
        this.numPages = Math.ceil( this.collectionSize / this.paginationConfig.pageSize);
        this.pageMhData = [];

        if ( this.pagerPage === this.numPages && lastPageCount !== 0 ) {
            for ( let i = numToSkip; i < numToSkip + lastPageCount; i++ ) {

                this.pageMhData.push( this.listOfMh[i] );
            }
        } else {
            for ( let i = numToSkip; i < numToSkip + 30; i++ ) {
                this.pageMhData.push( this.listOfMh[i] );
            }
        }
        this.showSpinner = false;
    }

    // ----------------------------------------------------------
    // sortandfilter bar methods
    // ----------------------------------------------------------
    nextPageChanger(step: number) {
        // negative number moves back, positive moves next
        this.pagerPage = this.pagerPage + step;
        this.pageChanger();
    }

    firstPageChanger() {
        this.pagerPage = 1;
        this.pageChanger();
    }

    lastPageChanger() {
        this.pagerPage = this.numPages;
        this.pageChanger();
    }

    filterFieldChange() {
        this.showSpinner = true;
        if (this.filterField === '' && this.listOfMhTemp !== null) {
            // Reset filter and show all rows if no filter field is selected
            this.listOfMh = this.listOfMhTemp;
            this.collectionSize = this.listOfMh.length;
            this.listOfMhTemp = null;
            this.filterText = '';
            this.pageChanger();
        } else if (this.filterText !== '' ) {
            this.applyFilter();
        }
        this.showSpinner = false;
    }

    applyFilter() {
        this.showSpinner = true;
        this.pagerPage = 1;
        if (this.filterText === '') {
            // Remove filter and reset if no filter string is empty
            this.listOfMh = this.listOfMhTemp;
            this.collectionSize = this.listOfMh.length;
            this.listOfMhTemp = null;
            this.pageChanger();
            return;
        }

        if (this.listOfMhTemp === null) {
            // If its the first character in filter then tem is empty so set it
            this.listOfMhTemp = this.listOfMh;
        }

        // Filter out item according to filter text
        let that = this;
        this.listOfMh = this.listOfMhTemp.filter( item => {
            if (item[that.filterField] !== null) {
                if (that.filterField === 'MHNo'
                || that.filterField === 'Description'
                || that.filterField === 'Status'
                || that.filterField === 'Label'
                || that.filterField === 'PackagingOwner') {
                    return item[that.filterField].toLowerCase().includes(that.filterText.toLowerCase());
                } else {
                    return  String(item[that.filterField]).includes(that.filterText.toLowerCase());
                }
            }
        });

        this.collectionSize = this.listOfMh.length;
        this.pageChanger();
    }

    sortBy(fieldToSortBy: string) {
        this.showSpinner = true;
        if (this.sortField !== fieldToSortBy) {
            // If another column is clicked, set default to asc
            this.sortOrder = 'asc';
            this.sortField = fieldToSortBy;
        } else {
            // Toggle asc / desc
            this.sortOrder = this.sortOrder === 'asc'
                ? 'desc'
                : 'asc';
        }
        this.sort();
        this.pagerPage = 1;
        this.pageChanger();
    }

    sort() {
        this.listOfMh.sort( (a, b ) => {
            if (this.sortField === 'SomeDateFieldName') {
                // Date sort
                const left = Number(new Date(a[this.sortField]));
                const right = Number(new Date(b[this.sortField]));
                return (this.sortOrder === 'asc')
                    ? left - right
                    : right - left;
            } else if (this.sortField === 'Weight'
                || this.sortField === 'Length'
                || this.sortField === 'Width'
                || this.sortField === 'Height') {
                // Numeric sort
                return (this.sortOrder === 'asc')
                    ? a[this.sortField] - b[this.sortField]
                    : b[this.sortField] - a[this.sortField];
            } else if (this.sortField === 'SomeBooleanFieldName') {
                // Boolean sort
                const left = a[this.sortField] === false ? 0 : 1;
                const right = b[this.sortField] === false ? 0 : 1;
                return (this.sortOrder === 'asc')
                    ? right - left
                    : left - right;
            } else {
                // string sort
                const aVal = a[this.sortField] === null
                    ? ''
                    : a[this.sortField].toLowerCase();

                const bVal = b[this.sortField] === null
                    ? ''
                    : b[this.sortField].toLowerCase();

                if (aVal < bVal) {
                    return (this.sortOrder === 'asc' ) ? -1 : 1;
                } else if (aVal > bVal) {
                    return (this.sortOrder === 'asc' ) ?  1 : -1;
                } {
                    return 0;
                }
            }
        });
    }


    // ----------------------------------------------------------
    // Excel download methods
    // ----------------------------------------------------------
    downloadExcel() {
        const showPrice = (this.user.IsPackagingAdmin
            || this.user.IsPackagingEngineer
            || this.user.IsPurchaser
            || this.user.IsDeveloper );
        window.open(this.config.get('apiUrl') + `/PackagingMaterial/CreateMaterialListExcel?showPrice=${showPrice}`, '_blank');
    }

    downloadDUExcel() {
        window.open(this.config.get('apiUrl') + '/DistributionUnit/CreateDUListExcel/', '_blank');
    }


    // ----------------------------------------------------------
    // Error, warning and info
    // ----------------------------------------------------------
    error(message: string, source: string, errType: ErrorTypeEnum): void {
        throw new ErrorObject(message, source, errType);
    }

    // ----------------------------------------------------------
    // Misc logic
    // ----------------------------------------------------------
    setDefaultStatusSelection() {
        this.searchStatusIds = [];
        this.searchStatusIds.push(1);
        this.searchStatusIds.push(5);
        this.searchStatusIds.push(8);
    }

    reset() {
        this.searchMHNo = '';
        this.searchDescription = '';
        this.setDefaultStatusSelection();
        this.searchOwnerId = 1;
        this.listOfMh = null;
        this.searchLengthFrom = null;
        this.searchLengthTo = null ;
        this.searchWidthFrom = null ;
        this.searchWidthTo = null ;
        this.searchHeightFrom = null ;
        this.searchHeightTo = null ;
        this.filterField = '';
        this.filterFieldChange();
    }

    canExport() {
        const canExport = this.user.IsPackagingAdmin
        || this.user.IsPackagingEngineer
        || this.user.IsDeveloper
        || this.user.IsPurchaser;

        return canExport;
    }
}



// WEBPACK FOOTER //
// C:/Users/NREGE3/Workspace/OnPremChina/PackITWebGui/src/app/packaging-material-search/packaging-material-search.component.ts